module.exports = __webpack_public_path__ + "static/MittagstischDark-ade080125e333e0b0ee1d57b0c64ce66.png";